import React from 'react'
import { intl } from 'lang/intl'
import classnames from 'classnames'

import { TtIcon } from '@23/ui-react'

import { AudioLevelIndicator } from '../../../../../RoomUI/components/AudioLevelIndicator/AudioLevelIndicator'
import { useFullParticipantInfo } from '../../../../../webrtc/webRTCRoom'

import './MuteAudioTrigger.scss'

interface MuteAudioTriggerProps {
  participantId: number
  isMuted: boolean
  toggleAudio: () => void
  isMutingAllowed: boolean
  isLocal: boolean
}

const MuteAudioTrigger = ({
  participantId,
  isMuted,
  toggleAudio,
  isMutingAllowed = false,
  isLocal,
}: MuteAudioTriggerProps) => {
  const participant = useFullParticipantInfo(participantId)

  let ariaLabel

  if (isLocal) {
    if (isMuted) {
      ariaLabel = intl.formatMessage({
        defaultMessage: 'Press enter or space to unmute',
      })
    } else {
      ariaLabel = intl.formatMessage({
        defaultMessage: 'Press enter or space to mute your mic',
      })
    }
  } else if (!isLocal && isMuted) {
    ariaLabel = intl.formatMessage(
      { defaultMessage: 'Press enter or space to unmute {name}' },
      { name: participant?.name }
    )
  } else {
    ariaLabel = intl.formatMessage(
      {
        defaultMessage: 'Press enter or space to mute {name}',
      },
      { name: participant?.name }
    )
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    toggleAudio()
  }

  return (
    <div
      className={classnames('mute-audio-trigger-wrapper', {
        'audio-disabled': isMuted,
      })}
    >
      <button
        type="button"
        className={classnames('mute-audio-trigger', {
          muted: isMuted,
          interactive: isMutingAllowed,
        })}
        aria-label={ariaLabel}
        onClick={isMutingAllowed ? handleClick : undefined}
      >
        {participant?.tracks.cameraAudio && (
          <AudioLevelIndicator
            audioTrack={participant.tracks.cameraAudio.mediaStream}
            enabled={!!participant.tracks.cameraAudio?.isEnabled}
          />
        )}
        <TtIcon
          className="microphone-icon"
          name={
            !participant?.tracks.cameraAudio?.isEnabled ? 'mic-off' : 'mic-on'
          }
          library="one/webinars"
        />
      </button>
    </div>
  )
}

export { MuteAudioTrigger }
